import { updateLocationSearch } from 'app/functions';
import { returnDateTimestampSelector, returnDateVisibleSelector } from '../../selectors';
import { ThunkType } from 'app/hooks/appHooks';
import { setDepartureDate, setReturnDate } from 'app/store/reducers/date';
import { format, parseISO } from 'date-fns';

export type UpdateDatesType = { tripIndex: number; newDateUTC: string };

export const updateDates = ({ tripIndex, newDateUTC }: UpdateDatesType): ThunkType<void> => {
  return (dispatch, getState) => {
    const state = getState();

    const RIDE_DATE = 'rideDate';
    const BACK_RIDE_DATE = 'backRideDate';
    const urlParams = new URLSearchParams(window.location.search);
    // date-fns at current version fails to correctly retrieve date for iso time string
    // fix by providing only date (w/o time) as it's irrelevant for this feature
    const dateFromIsoTime = newDateUTC.split('T')[0];
    const newDateFormatted = format(parseISO(dateFromIsoTime), 'dd.MM.yyyy');
    // extract integer values from formatted date
    const [year, month, day] = newDateFormatted
      .split('.')
      .reverse()
      .map((s) => parseInt(s, 10));
    // create UTC seconds timestamp / use UTC to avoid unintended time conversion
    const newDateTimeInUtcSeconds =
      Date.UTC(year, month - 1, day) / 1000 + new Date().getTimezoneOffset() * 60;
    if (tripIndex === 0) {
      urlParams.set(RIDE_DATE, newDateFormatted);
    }

    const returnDate = returnDateTimestampSelector(state);
    const returnDateVisible = returnDateVisibleSelector(state);

    if (returnDateVisible && returnDate < newDateTimeInUtcSeconds && tripIndex === 1) {
      urlParams.set(BACK_RIDE_DATE, newDateFormatted);
    }

    updateLocationSearch(urlParams);
    if (tripIndex === 0) {
      dispatch(setDepartureDate({ date: newDateTimeInUtcSeconds }));
    }
    if (tripIndex === 1) {
      dispatch(setReturnDate({ date: newDateTimeInUtcSeconds }));
    }
  };
};
